import _get from 'lodash/get'

export default {
	methods: {
		__get(obj, path) {
			return _get(obj, path)
		}
	}
}
